document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.wp-block-brblocks-br-img img');

  images.forEach((img) => {
    const parentDiv = img.closest('.wp-block-brblocks-br-img');
    if (!parentDiv) return;

    // Modal désactivé sur ce bloc
    if (parentDiv.getAttribute('data-enable-modal') === 'false') return;

    // Si l'image est dans un lien, ne pas activer le lightbox
    if (img.closest('a')) return;

    img.style.cursor = 'pointer';

    img.addEventListener('click', () => {
      const showWhiteBackground =
        parentDiv.getAttribute('data-show-white-background') === 'true';

      const modal = document.createElement('div');
      modal.style.position = 'fixed';
      modal.style.top = '0';
      modal.style.left = '0';
      modal.style.width = '100%';
      modal.style.height = '100%';
      modal.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
      modal.style.display = 'flex';
      modal.style.justifyContent = 'center';
      modal.style.alignItems = 'center';
      modal.style.zIndex = '1000';
      modal.style.boxSizing = 'border-box';
      modal.style.cursor = 'pointer';

      const modalContent = document.createElement('div');
      if (showWhiteBackground) {
        modalContent.style.backgroundColor = 'white';
        modalContent.style.padding = '20px';
        modalContent.style.borderRadius = '5px';
        modalContent.style.boxSizing = 'border-box';
      }

      const modalImage = document.createElement('img');
      modalImage.src = img.src;
      modalImage.alt = img.alt || '';
      modalImage.style.maxWidth = '80vw';
      modalImage.style.maxHeight = '60vh';

      modalContent.appendChild(modalImage);
      modal.appendChild(modalContent);
      document.body.appendChild(modal);

      document.body.style.overflow = 'hidden';

      const closeModal = () => {
        if (modal.parentNode) {
          document.body.removeChild(modal);
        }
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKeydown);
      };

      const onKeydown = (event) => {
        if (event.key === 'Escape') {
          closeModal();
        }
      };

      modal.addEventListener('click', closeModal);
      document.addEventListener('keydown', onKeydown);
    });
  });
});